(function() {
    $(document).ready(function() {
        if (document.querySelector('.vss')) {
            const anchorChips = document.querySelectorAll('.c24m-anchor-chip');
            let dynamicChipsLength = document.querySelectorAll('.c24m-dynamic-chip').length;
            if (!anchorChips.length) {
                return;
            }

            for (const chip of anchorChips) {
                const chipAnchor = chip.getAttribute('href').replace('#', '');
                const anchor = document.getElementById(chipAnchor);
                if (!anchor) {
                    chip.remove();
                    continue;
                }
                dynamicChipsLength++;
                chip.dataset.position = dynamicChipsLength;
            }
        }
    });
})();
